import { Flex, Tag, Typography } from 'antd';
import type { TagProps } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

export type GenericNotificationProps = {
  title: string;
  description: string;
  tag?: TagProps;
  link?: { text: string; link: string };
};

export function GenericNotification({ title, description, tag, link }: GenericNotificationProps) {
  return (
    <Flex vertical gap={4}>
      <Flex align="flex-start" justify="space-between">
        <Typography.Text strong>{title}</Typography.Text>
        {tag && <Tag {...tag} />}
      </Flex>
      {description && <Typography.Text>{description}</Typography.Text>}
      {link && <Typography.Link href={link.link}>{link.text} <ArrowRightOutlined aria-hidden="true" /></Typography.Link>}
    </Flex>
  );
}
